/**
 * Clamp a number between a min and max.
 * @param {number} value Value to clamp
 * @param {number} min Minimum value
 * @param {number} max Maximum value
 * @return {number} Clamped value
 */
export const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

/**
 * Clear and nullify a timer ref.
 * @param {Object} ref Ref object with current timer ID
 * @return {void}
 */
export const clearTimer = (ref) => {
  if (ref?.current) {
    clearTimeout(ref.current);
    ref.current = null;
  }
};
